// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'

// Initialize Firebase - Copied from firebase
// const firebaseConfig = {
//   apiKey: "AIzaSyAvDBb0EY5wbXHrBJ6tPAquvfKDAt77PSA",
//   authDomain: "senfu-lobsters.firebaseapp.com",
//   databaseURL: "https://senfu-lobsters.firebaseio.com",
//   projectId: "senfu-lobsters",
//   storageBucket: "senfu-lobsters.appspot.com",
//   messagingSenderId: "145884903022",
//   appId: "1:145884903022:web:80b619d49e5a51a735187f"
// };

// Senfu oficial
const firebaseConfig = {
  apiKey: "AIzaSyAqBKg9p0IcEbctyVKiNkPB2whr8lfuZB4",
  authDomain: "senfucen.firebaseapp.com",
  databaseURL: "https://senfucen.firebaseio.com",
  projectId: "senfucen",
  storageBucket: "senfucen.appspot.com",
  messagingSenderId: "426898487052",
  appId: "1:426898487052:web:a2dd08d96e745ecdb13b29"
};

firebase.initializeApp(firebaseConfig);
